export default __webpack_public_path__ + "static/media/email.812a9c7b.svg";